import { checkDeviceType, pollForIosCallback } from '@/src/utils/browser'
import { useRouter } from 'next/navigation'

const useRedirectToHome = () => {
    const router = useRouter()

    const goToHome = async ({ isReloadRequired = false }) => {
        // temp fix for android need to changes the logic for IOS
        if (checkDeviceType() === 'AndroidApp') {
            window?.MobileApp?.onBackBtnClick?.('FLIGHTS_HOME')
        } else if (typeof window?.webkit?.messageHandlers['FLIGHTS_HOME'] == 'object') {
            if (typeof window?.webkit?.messageHandlers['FLIGHTS_HOME'] == 'object') {
                window.webkit.messageHandlers['FLIGHTS_HOME'].postMessage('')
            } else {
                const response = await pollForIosCallback()
                if (response === 'SUCCESS') {
                    window.webkit.messageHandlers['FLIGHTS_HOME'].postMessage('')
                } else {
                    router.push('/')
                }
            }
        } else if (window.parent.androidData && window.parent.androidData['app-agent']) {
            window.parent?.MobileApp?.onBackBtnClick?.('FLIGHTS_HOME_PAGE')
        } else if (window?.parent?.iosData && window?.parent?.iosData['app-agent']) {
            window.parent?.webkit?.messageHandlers['FLIGHTS_HOME_PAGE']?.postMessage('')
        } else if (isReloadRequired) {
            window.location.href = '/'
        } else {
            router.push('/')
        }
    }

    return goToHome
}

export default useRedirectToHome
